import React from "react";
import "../ProductCardsModems.css";
import { Link } from "react-router-dom"; 
import '../../i18n';
import { useTranslation } from 'react-i18next';

import ImageSpin26Quanta from "../../assets/images/modems/processed/quanta_spin26.png"

const Spin26_QUANTA = () => {
  const { t, i18n } = useTranslation();
  
  return (
     <Link to="/acoustic_modems#spin26_quanta_spec" className="card-link-wrapper">
        <div class="card">
          <img src={ImageSpin26Quanta} alt={t('products.types.communcation_26_QUANTA.title')} class="card-image" />
          <div class="card-content">
            <h3 class="card-title">{t('products.types.communcation_26_QUANTA.title')}</h3>
            <p className="card-description">
              <ul class="features-list">
                <li>{t('products.types.communcation_26_QUANTA.li_1')}</li>
                <li>{t('products.types.communcation_26_QUANTA.li_2')}</li>
                <li>{t('products.types.communcation_26_QUANTA.li_3')}</li>
                <li>{t('products.types.communcation_26_QUANTA.li_4')}</li>
                <li>{t('products.types.communcation_26_QUANTA.li_5')}</li>
                <li>{t('products.types.communcation_26_QUANTA.li_6')}</li>
              </ul>
            </p>
          </div>
        </div>
      </Link>
  );
};
export default Spin26_QUANTA;